(function($) {
  "use strict";

  jQuery(document).ready(function(){


    
            
	       var $window_2 = $(window);
      $window_2.on('scroll', function () {
        var scroll = $window_2.scrollTop();
        if (scroll < 500) {
          $(".product-addtocart-sticky").removeClass("is-sticky-2");
        } else {
          $(".product-addtocart-sticky").addClass("is-sticky-2");
        }
      });

    
/*---------------------------------
	2. Header Top Dropdown Menu 
-----------------------------------*/
$( '.drodown-show > a,.shopping-cart li > a' ).on('click', function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {
        $( '.drodown-show > a,.shopping-cart li > a' ).removeClass('active').siblings('.open-dropdown').slideUp()
        $(this).removeClass('active').siblings('.open-dropdown').slideUp();
    } else {
        $( '.drodown-show > a , .shopping-cart li > a' ).removeClass('active').siblings('.open-dropdown').slideUp()
        $(this).addClass('active').siblings('.open-dropdown').slideDown();
    }
});
 
/*-- DeopDown Menu --*/
$('.mega-menu,.dropdown-menu').hide();
if( $(window).width() > 991 ) {
    $('.main-menu > nav > ul > li').hover(
      function() {
        if( $(this).children('ul').size() > 0 && $(this).children().hasClass('mega-menu') || $(this).children().hasClass('dropdown-menu') ) {
            $(this).children().stop().slideDown(300);
        }
      }, function() {
        $(this).children('.mega-menu,.dropdown-menu').stop().slideUp(300);
      }
    );
};   
    
/*---------------------------
	Count Down Timer
----------------------------*/
$('[data-countdown]').each(function() {
	var $this = $(this), finalDate = $(this).data('countdown');
	$this.countdown(finalDate, function(event) {
		$this.html(event.strftime('<span class="cdown day"><span class="time-count">%-D</span> <p>Days</p></span> <span class="cdown hour"><span class="time-count">%-H</span> <p>Hours</p></span> <span class="cdown minutes"><span class="time-count">%M</span> <p>Minute</p></span> <span class="cdown second"><span class="time-count">%S</span> <p>Second</p></span>'));
	});
});      
    
    
/*------------------------------ 
    10. Cart Plus Minus Button
---------------------------------*/
 $(".cart-plus-minus").append('<div class="dec qtybutton"><i class="fa fa-angle-down"></i></div><div class="inc qtybutton"><i class="fa fa-angle-up"></i></div>');
  $(".qtybutton").on("click", function() {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if ($button.hasClass('inc')) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
       // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
        } else {
        newVal = 0;
      }
      }
    $button.parent().find("input").val(newVal);
  });    
 
 
/*----------------------------------
    ScrollUp Active
-----------------------------------*/
$.scrollUp({
    scrollText: '<i class="fa fa-angle-double-up"></i>',
    easingType: 'linear',
    scrollSpeed: 900,
    animation: 'fade'
});

 /*------------------------------
     4.2 Category menu Activation
------------------------------*/
    $('.category-sub-menu li.has-sub > a').on('click', function () {
        $(this).removeAttr('href');
        var element = $(this).parent('li');
        if (element.hasClass('open')) {
            element.removeClass('open');
            element.find('li').removeClass('open');
            element.find('ul').slideUp();
        } else {
            element.addClass('open');
            element.children('ul').slideDown();
            element.siblings('li').children('ul').slideUp();
            element.siblings('li').removeClass('open');
            element.siblings('li').find('li').removeClass('open');
            element.siblings('li').find('ul').slideUp();
        }
    });  

/*-------------------------
  showlogin toggle function
--------------------------*/
	 $( '#showlogin' ).on('click', function() {
        $( '#checkout-login' ).slideToggle(500);
     }); 
    
/*-------------------------
  showcoupon toggle function
--------------------------*/
	 $( '#showcoupon' ).on('click', function() {
        $( '#checkout-coupon' ).slideToggle(500);
     });
    
/*--- Checkout ---*/
$("#chekout-box").on("change",function(){
    $(".account-create").slideToggle("100");
});
    
/*-- Checkout -----*/
$("#chekout-box-2").on("change",function(){
    $(".ship-box-info").slideToggle("100");
});   
    
/*------------------------------
   fixed stickymenu  
--------------------------------*/
    var stickymenu = document.getElementById("stickymenu")
    var stickymenuoffset = stickymenu.offsetTop
    var scrolltimer

    window.addEventListener("scroll", function(e){
        requestAnimationFrame(function(){
            if (window.pageYOffset > stickymenuoffset){
                stickymenu.classList.add('sticky')
            }
            else{
                stickymenu.classList.remove('sticky')
            }
        })
    });
    
    
    

    /* Match Heigh   
        $('.item').matchHeight();
        */

    /* Thumbnail Video 
      $('#ProductPhoto').append('<iframe src="https://www.youtube.com/embed/uQBL7pSAXR8"></iframe>');
      $('.product-single__thumbnail').on('click', function() {
        var $this = $(this);
        if($this.children('img[alt*="youtube"]').length || $this.children('img[alt*="vimeo"]').length){
          var $video = $this.children('img').attr('alt');
          console.log($video);

          $('#ProductPhoto img').hide();
          $('#ProductPhoto iframe').attr('src', $video);
          $('#ProductPhoto .video-wrapper').show();
        } else {
          $('#ProductPhoto img').show();
          $('#ProductPhoto .video-wrapper').hide();
        }
      });


    });

  jQuery(window).on('load',function(){

    $('#ProductPhoto .video-wrapper').hide();

  });
  */


  });
  
})(jQuery);



